// assets
import { IconKey, IconUser, IconList, IconUsers, IconUserShield, IconCloud, IconFileAnalytics, IconReportMoney, IconHeadset } from '@tabler/icons-react';

// constant
const icons = {
    IconKey,
    IconUser,
    IconList,
    IconUsers,
    IconUserShield,
    IconCloud,
    IconFileAnalytics,
    IconReportMoney,
    IconHeadset,
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const pages = {
    id: 'pages',
    title: 'Menus',
    //caption: 'Pages Caption',
    type: 'group',
    children: [
        {
            id: "tables",
            title: "Tabelas",
            type: 'collapse',
            icon: icons.IconList,
            
            children: [
                {
                    id: 'lawyers',
                    title: 'Advogados',
                    type: 'item',
                    url: '/lawyers/list',
                },
                {
                    id: 'sales_consultants',
                    title: 'Consultores de vendas',
                    type: 'item',
                    url: '/sales_consultants/list',
                },
                {
                    id: 'marital-status',
                    title: 'Estados Civis',
                    type: 'item',
                    url: '/marital-status/list',
                },
                {
                    id: 'contract-types',
                    title: 'Tipos de contrato',
                    type: 'item',
                    url: '/contract-types/list',
                },
                {
                    id: 'professions',
                    title: 'Profissões',
                    type: 'item',
                    url: '/professions/list',
                },
                /*
                {
                    id: 'neighborhoods',
                    title: 'Bairros',
                    type: 'item',
                    url: '/neighborhoods/list',
                    target: true
                },
                {
                    id: 'cities',
                    title: 'Cidades',
                    type: 'item',
                    url: '/cities/list',
                    target: true
                },
                {
                    id: 'streets',
                    title: 'Logradouros',
                    type: 'item',
                    url: '/streets/list',
                    target: true
                }*/
            ]
        },
        {
            id: "registration",
            title: "Cadastros",
            type: 'collapse',
            icon: icons.IconUser,

            children: [
                {
                    id: 'banks',
                    title: 'Bancos',
                    type: 'item',
                    url: '/banks/list',
                },
                {
                    id: 'customers',
                    title: 'Clientes',
                    type: 'item',
                    url: '/customers/list',
                },
                {
                    id: 'contracts',
                    title: 'Contratos',
                    type: 'item',
                    url: '/contracts/list',
                }

            ]
        },
        {
            id: 'attendances-menu',
            title: 'Atendimento',
            type: 'collapse',
            icon: icons.IconHeadset,

            children: [
                {
                    id: 'attendances',
                    title: 'Atendimentos',
                    type: 'item',
                    url: '/attendances/list',
                }
            ]
        },
        {
            id: 'reports-menu',
            title: 'Relatórios',
            type: 'collapse',
            icon: icons.IconReportMoney,

            children: [
                {
                    id: 'commissions-report',
                    title: 'Comissões dos consultores',
                    type: 'item',
                    url: '/reports/comissoes',
                }
            ]
        },
        {
            id: 'user-management',
            title: 'Gestão de Usuários',
            type: 'collapse',
            icon: icons.IconUsers,

            children: [
                {
                    id: 'users',
                    title: 'Usuários',
                    type: 'item',
                    url: '/users/list',
                    icon: icons.IconUser
                },
                {
                    id: 'user-profiles',
                    title: 'Perfis de Usuário',
                    type: 'item',
                    url: '/user-profiles/list',
                    icon: icons.IconUserShield
                },
                {
                    id: 'google-drive',
                    title: 'Google Drive',
                    type: 'item',
                    url: '/google-drive',
                    icon: icons.IconCloud
                },
                {
                    id: 'audit-download-logs',
                    title: 'Log de Downloads',
                    type: 'item',
                    url: '/audit/download-logs',
                    icon: icons.IconFileAnalytics
                }
            ]
        },
        {
            id: 'authentication',
            title: 'Authentication',
            type: 'collapse',
            icon: icons.IconKey,

            children: [
                {
                    id: 'login3',
                    title: 'Login',
                    type: 'item',
                    url: '/login',
                    target: true
                },
                // {
                //     id: 'register3',
                //     title: 'Register',
                //     type: 'item',
                //     url: '/pages/register/register3',
                //     target: true
                // }
            ]
        }
    ]
};

export default pages;
